import './style.css'
import ReactDOM from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import { Suspense, useState, useEffect } from 'react'
import { useProgress } from '@react-three/drei'
import Experience from './Experience.jsx'

function Loader() {
    const { progress } = useProgress()
    const [displayProgress, setDisplayProgress] = useState(0)
    const [fadeOut, setFadeOut] = useState(false)
    const [isComplete, setIsComplete] = useState(false)

    useEffect(() => {
        if (progress < 99) {
            setDisplayProgress(Math.floor(progress))
        } else if (progress >= 99 && !isComplete) {
            setDisplayProgress(99)
            const timer = setTimeout(() => {
                setDisplayProgress(100)
                setTimeout(() => {
                    setFadeOut(true)
                    setTimeout(() => setIsComplete(true), 500)
                }, 300)
            }, 1000)
            return () => clearTimeout(timer)
        }
    }, [progress, isComplete])

    if (isComplete) return null

    return (
        <div className={`loader ${fadeOut ? 'fade-out' : ''}`}>
            <div className="loader-content">
                <div className="portal-ring">
                    <div className="portal-ring-outer" />
                    <div className="portal-glow" />
                    <div className="portal-center" />
                </div>
                <div className="loader-bar-container">
                    <div
                        className="loader-bar"
                        style={{ width: `${displayProgress}%` }}
                    />
                </div>
                <div className="loader-text">{displayProgress}%</div>
            </div>
        </div>
    )
}

const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(
    <>
        <Loader />
        <Canvas
            flat
            camera={ {
                fov: 45,
                near: 0.1,
                far: 200,
                position: [ 1, 2, 6 ]
            } }
        >
            <Suspense fallback={ null }>
                <Experience />
            </Suspense>
        </Canvas>
    </>
)